import type { DiagramType } from '../../../lib/diagram/registries';
import { findSubtypeForEdge } from '../../../lib/diagram/registries';
import i18n from '../../../i18n/config';

function translateRelationshipPackLabel(packLabel: string): string {
  if (packLabel.startsWith('relationships.')) {
    return String(i18n.t(`diagram:${packLabel}`, packLabel));
  }
  if (packLabel.startsWith('connector.types.')) {
    return String(i18n.t(`diagram:${packLabel}`, packLabel));
  }
  return packLabel;
}

export function resolveGenogramConnectorDisplayLabel(params: {
  diagramType: DiagramType;
  edgeType: string;
  attrs: Record<string, unknown>;
  showCaptions: boolean;
}): string | undefined {
  const { diagramType, edgeType, attrs, showCaptions } = params;
  if (edgeType === 'child') return undefined;

  if (attrs.__captionHidden === true) return undefined;

  const rawLabel = typeof attrs.label === 'string' ? attrs.label.trim() : '';
  if (rawLabel.length > 0) return rawLabel;

  if (!showCaptions) return undefined;

  const subtype = findSubtypeForEdge(diagramType, edgeType, attrs);
  if (!subtype) return undefined;
  return translateRelationshipPackLabel(subtype.label);
}
